<template>
  <b-form>
    <b-form-group :label="$lang('ctype')">        
        <b-form-select required v-model="item.can_type" :options='cancelTypes'></b-form-select>
    </b-form-group>
    <b-form-group :label="$lang('dbeg')" v-show="showDates">        
        <b-form-input v-model="item.dbeg" type='date' ></b-form-input>
    </b-form-group>
    <b-form-group :label="$lang('dend')" v-show="showDates">        
        <b-form-input v-model="item.dend" type='date' ></b-form-input>
    </b-form-group>
    <b-form-group :label="$lang('remark')">
        <b-form-textarea v-model="item.remark"></b-form-textarea>
    </b-form-group>  
    <b-alert v-if="item.error" show variant="danger">{{item.error}}</b-alert>
    <div v-if="item.wait" class="d-flex mt-1">
        <b-spinner variant="primary"></b-spinner>
        <span class="ml-3 mt-1">{{$lang('saving')}}</span>
    </div>
  </b-form>
</template>

<script>
export default {
    props: ['item'],
    data() {
       return {
          cancelTypes: [
            {value: 1, text: this.$lang('ct_full')},
            {value: 2, text: this.$lang('ct_part')},
          ] 
       }
    },
    computed: {
        showDates: function() {
          return this.item.can_type == 2;
        },
    },
    locales: {
    en: {
        ctype: "Cancelation Type:",
        dbeg: "Cancel From:",
        dend: "Cancel Until:",
        remark: "Remark:",
        saving: "Saving document, please wait...",
        errdate: "Please enter valid date",
        ct_full: "Full",
        ct_part: "Partially",
      },
    de: {
        ctype: "Stornierung Art:",
        dbeg: "Stornierung von Datum:",
        dend: "Stornierung bis Datum:",
        remark: "Bemerkungen:",
        saving: "Dokument wird gespeichert, bitte warten...",
        errdate: "Bitte geben Sie ein gültiges Datum ein",
        ct_full: "Voll Stornierung",
        ct_part: "Teil Stornierung",
    },
    ru: {
        ctype: "Тип отмены:",
        dbeg: "Отмена с:",
        dend: "Отмена по:",
        remark: "Примечания:", 
        saving: "Сохранение документа, пожалуйста подождите...",
        errdate: "Введите корректную дату",
        ct_full: "Полная отмена",
        ct_part: "Частичная отмена",
    },  
    pl: {
        ctype: "Opcja anulowania:",
        dbeg: "Anuluj od daty:",
        dend: "Anuluj przed datą:",
        remark: "Uwagi:", 
        saving: "Zapisywanie dokumentu. Proszę czekać...",
        errdate: "Proszę wprowadź poprawną datę",
        ct_full: "Całkowite anulowanie",
        ct_part: "Częściowe anulowanie",
    }    
  }   
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/CancelationItem.vue